import { createContext, useContext } from 'react';

export type PredictiveSearchResult = Partial<{
  service: string;
  sections: Array<{
    title: string;
    sectionType: string;
    link: string;
    items: unknown[];
  }>;
  trackingToken: unknown;
}>;

export type PredictiveSearchFunction = (
  searchTerm: string,
  consumer: string
) => Promise<void>;

export type PredictiveSearchHandler = {
  search: PredictiveSearchFunction;
  reset: () => void;
  track: (messages: FullTrackingInput[]) => void;
};

export const PredictiveSearchResultContext = createContext<
  PredictiveSearchResult | undefined
>(undefined);

export const PredictiveSearchContext = createContext<PredictiveSearchHandler>({
  search: async () => undefined,
  reset: () => undefined,
  track: () => undefined,
});

export function usePredictiveSearchHandler(): PredictiveSearchHandler {
  return useContext(PredictiveSearchContext);
}

export function usePredictiveSearchResult():
  | PredictiveSearchResult
  | undefined {
  return useContext(PredictiveSearchResultContext);
}

export type FullTrackingInput = {
  consumer: string;
  interactionType: string;
  position?: number | null;
  receivedTimestamp?: string | null;
  service: string;
  timestamp?: string | null;
  trackingToken: string;
  userId?: string | null;
};
